import * as React from "react";
import PropTypes from 'prop-types';

const SvgInfoFill = props => {
  if (props.id !== "_svginfofill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fillRule="evenodd" d="M20 15.71a2.14 2.14 0 110-4.28 2.14 2.14 0 010 4.28zm-2.14 12.86h4.28V17.86h-4.28v10.71zM20 5C11.716 5 5 11.716 5 20c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15A15.001 15.001 0 0020 5z" /></svg>;
};

SvgInfoFill.displayName = "_svginfofill";
SvgInfoFill.propTypes = {
  id: PropTypes.string
};
SvgInfoFill.defaultProps = {
  id: ''
};
export default SvgInfoFill;